define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Component) => {
  const { classNames } = Util;
  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'lineHeight',
    'boxShadow',
    'textShadow',
  ];

  function Checkbox(props) {
    const { option, style, defaultChecked } = props;
    const label = option.get('label');
    const value = option.get('value');
    const containerStyle = _.extend({ margin: '0', display: 'block' }, style);

    function onChange(e) {
      const { onChange, option } = props;

      if (onChange) onChange(label, value, e.currentTarget.checked);
    }

    return (
      <label style={containerStyle}>
        <input type="checkbox" defaultChecked={defaultChecked} onChange={onChange} />
        <span style={{ paddingLeft: '8px' }}>{label}</span>
      </label>
    );
  }

  @Component({ disableVerticalResize: true })
  class CheckboxGroup extends React.Component {
    static propTypes = {
      label: PropTypes.string,
      options: PropTypes.object,
      style: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    }

    constructor(props) {
      super(props);

      const selected = [];
      if (props.options && props.defaultValue) {
        const defaultValues = _.pluck(props.defaultValue, 'value').filter(Boolean);
        props.options.forEach(option => {
          const label = option.get('label');
          const value = option.get('value');
          const defaultChecked = (defaultValues.indexOf(value) >= 0);

          if (defaultChecked) {
            selected.push({ label, value });
          }
        });
      }

      this.state = {
        selected: Immutable.fromJS(selected)
      };

      this.onChangeItem = this.onChangeItem.bind(this);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue && nextProps.options) {
        const selected = [];
        const defaultValues = _.pluck(nextProps.defaultValue, 'value').filter(Boolean);
        nextProps.options.forEach(option => {
          const label = option.get('label');
          const value = option.get('value');
          const defaultChecked = (defaultValues.indexOf(value) >= 0);

          if (defaultChecked) {
            selected.push({ label, value });
          }
        });

        this.setState({ selected: Immutable.fromJS(selected) });
      }
    }

    onChangeItem(label, value, checked) {
      const { name, onChangeForm } = this.props;
      const { selected } = this.state;
      const selectedOption = selected.find(option => (
        option.get('label') === label && option.get('value') === value
      ));
      let newSelected = selected;

      if (checked) {
        if (!selectedOption) {
          newSelected = selected.push(Immutable.Map({ label, value }));
        }
      } else {
        if (selectedOption) {
          const index = selected.indexOf(selectedOption);
          newSelected = selected.splice(index, 1);
        }
      }

      if (onChangeForm) onChangeForm({ [name]: newSelected.toJS() });
      if (newSelected !== selected) this.setState({ selected: newSelected });
    }

    getChildStyle() {
      return _.pick(this.props.style.toJS(), 'color');
    }

    renderCheckboxes() {
      const { options, defaultValue, onFocus, onBlur } = this.props;
      const checkboxes = [];

      const defaultValues = _.pluck(defaultValue, 'value').filter(Boolean);
      options.forEach(option => {
        const value = option.get('value');
        const defaultChecked = (defaultValues.indexOf(value) >= 0);

        checkboxes.push(
          <Checkbox
            key={option.get('id')}
            style={this.getChildStyle()}
            option={option}
            defaultChecked={defaultChecked}
            onChange={this.onChangeItem}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        );
      });

      return checkboxes;
    }

    render() {
      const {
        isPreview,
        label,
        options,
        onMouseEnter,
        onMouseLeave,
      } = this.props;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);

      style.padding = '0';
      style.margin = '0';
      style.display = 'block';
      style.width = '100%';
      style.textAlign = 'left'; // align to the left the group in the container

      const className = classNames(
        'sumome-react-label-style',
        { 'sumome-react-wysiwyg-overlay': isPreview },
      );

      return (
        <div
          ref={(el) => this.textEl = el}
          className={className}
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <label style={this.getChildStyle()}>{label}</label>
          {this.renderCheckboxes()}
        </div>
      );
    }
  }

  return CheckboxGroup;
});


